/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FeaturesObjectType,
    FeaturesObjectTypeFromJSON,
    FeaturesObjectTypeFromJSONTyped,
    FeaturesObjectTypeToJSON,
} from './FeaturesObjectType';

/**
 * 
 * @export
 * @interface ProgramFeatures
 */
export interface ProgramFeatures {
    /**
     * 
     * @type {FeaturesObjectType}
     * @memberof ProgramFeatures
     */
    object: FeaturesObjectType;
    /**
     * 
     * @type {string}
     * @memberof ProgramFeatures
     */
    program_id: string;
    /**
     * Program has completed the required configuration to successfully process payments.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    online_payments_enabled: boolean;
    /**
     * Program has session packages, and/or membership packages, and can offer sessions to customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    sessions_enabled: boolean;
    /**
     * Program has membership packages and can configure recurring payments for customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    memberships_enabled: boolean;
    /**
     * Program cannot publish more than the specified amount of events. There is no limit if not specified.
     * @type {number}
     * @memberof ProgramFeatures
     */
    max_monthly_camps?: number;
    /**
     * Program can only view the specified number of months in the past. There is no limit if not specified.
     * @type {number}
     * @memberof ProgramFeatures
     */
    months_of_history?: number;
    /**
     * Program can adjust and manage an account balance for their customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    account_balance_enabled: boolean;
    /**
     * (Workaround) Program has setup payouts and should be receiving money to their bank account.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    payouts_enabled: boolean;
    /**
     * Program has the ability to send and receive emails to their customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    communications_enabled: boolean;
    /**
     * Program has the ability to view a report of all registrations across all events.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    registration_report_enabled: boolean;
    /**
     * Program has the ability to view a report of all memberships.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    membership_report_enabled: boolean;
    /**
     * (Experimental) Program has the ability to view a report of all contacts.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    contact_report_enabled: boolean;
    /**
     * (Experimental) Program has the ability to view a report of all attendees.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    attendee_report_enabled: boolean;
    /**
     * Program will be able to collect and view feedback for their events.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    feedback_enabled: boolean;
    /**
     * Program can create discounts and coupon codes for their orders.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    discounts_enabled: boolean;
    /**
     * Program can have attendees register for an event without accepting payment. This should eventually be replaced with wishlist.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    preregistration_enabled: boolean;
    /**
     * Program has the ability to have customers register based on the organizer's schedule.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    appointments_enabled: boolean;
    /**
     * Program will have the ability to send email campaigns to their customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    email_campaigns_enabled: boolean;
    /**
     * Program supports "other" and "not specified" as gender options.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    expanded_gender_enabled: boolean;
    /**
     * (Experimental) Program will have early access to the new products features.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    products_enabled: boolean;
    /**
     * (Experimental) Program will be able to configure if push notifications are received on their devices.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    push_notifications_enabled: boolean;
    /**
     * (Experimental) Program will be able to auto suggest summaries for events and appointment types.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    suggestions_enabled: boolean;
    /**
     * (Experimental) Program will be able to process with terminal, new card element, and using Stripe Express Connect.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    payment_enhancements_enabled: boolean;
    /**
     * (Experimental) Program will be able to provide a Meta pixel ID for enhanced tracking.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    meta_pixel_enabled: boolean;
    /**
     * (Experimental) Program will be able to send SMS messages to their customers.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    sms_enabled: boolean;
    /**
     * (Experimental) Program will be able to view marketing insights for their program.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    marketing_insights_enabled: boolean;
    /**
     * (Workaround) Program will be able to have customers register for an event without accepting payment.
     * @type {boolean}
     * @memberof ProgramFeatures
     */
    external_registration_enabled: boolean;
}

export function ProgramFeaturesFromJSON(json: any): ProgramFeatures {
    return ProgramFeaturesFromJSONTyped(json, false);
}

export function ProgramFeaturesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramFeatures {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'object': FeaturesObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'online_payments_enabled': json['online_payments_enabled'],
        'sessions_enabled': json['sessions_enabled'],
        'memberships_enabled': json['memberships_enabled'],
        'max_monthly_camps': !exists(json, 'max_monthly_camps') ? undefined : json['max_monthly_camps'],
        'months_of_history': !exists(json, 'months_of_history') ? undefined : json['months_of_history'],
        'account_balance_enabled': json['account_balance_enabled'],
        'payouts_enabled': json['payouts_enabled'],
        'communications_enabled': json['communications_enabled'],
        'registration_report_enabled': json['registration_report_enabled'],
        'membership_report_enabled': json['membership_report_enabled'],
        'contact_report_enabled': json['contact_report_enabled'],
        'attendee_report_enabled': json['attendee_report_enabled'],
        'feedback_enabled': json['feedback_enabled'],
        'discounts_enabled': json['discounts_enabled'],
        'preregistration_enabled': json['preregistration_enabled'],
        'appointments_enabled': json['appointments_enabled'],
        'email_campaigns_enabled': json['email_campaigns_enabled'],
        'expanded_gender_enabled': json['expanded_gender_enabled'],
        'products_enabled': json['products_enabled'],
        'push_notifications_enabled': json['push_notifications_enabled'],
        'suggestions_enabled': json['suggestions_enabled'],
        'payment_enhancements_enabled': json['payment_enhancements_enabled'],
        'meta_pixel_enabled': json['meta_pixel_enabled'],
        'sms_enabled': json['sms_enabled'],
        'marketing_insights_enabled': json['marketing_insights_enabled'],
        'external_registration_enabled': json['external_registration_enabled'],
    };
}

export function ProgramFeaturesToJSON(value?: ProgramFeatures | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'object': FeaturesObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'online_payments_enabled': value.online_payments_enabled,
        'sessions_enabled': value.sessions_enabled,
        'memberships_enabled': value.memberships_enabled,
        'max_monthly_camps': value.max_monthly_camps,
        'months_of_history': value.months_of_history,
        'account_balance_enabled': value.account_balance_enabled,
        'payouts_enabled': value.payouts_enabled,
        'communications_enabled': value.communications_enabled,
        'registration_report_enabled': value.registration_report_enabled,
        'membership_report_enabled': value.membership_report_enabled,
        'contact_report_enabled': value.contact_report_enabled,
        'attendee_report_enabled': value.attendee_report_enabled,
        'feedback_enabled': value.feedback_enabled,
        'discounts_enabled': value.discounts_enabled,
        'preregistration_enabled': value.preregistration_enabled,
        'appointments_enabled': value.appointments_enabled,
        'email_campaigns_enabled': value.email_campaigns_enabled,
        'expanded_gender_enabled': value.expanded_gender_enabled,
        'products_enabled': value.products_enabled,
        'push_notifications_enabled': value.push_notifications_enabled,
        'suggestions_enabled': value.suggestions_enabled,
        'payment_enhancements_enabled': value.payment_enhancements_enabled,
        'meta_pixel_enabled': value.meta_pixel_enabled,
        'sms_enabled': value.sms_enabled,
        'marketing_insights_enabled': value.marketing_insights_enabled,
        'external_registration_enabled': value.external_registration_enabled,
    };
}

